export const FILTER_VALUE_KEY = 'value';
